import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96f83270"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "dialog-body-content" }
const _hoisted_3 = { class: "handle-result-body" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "dialog-footer" }

import { t } from '@/plugins/i18n'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  resultData: {
    type: Number,
    default: 0
  }
},
  emits: ['closeDialog', 'refresh'],
  setup(__props, { emit }) {

const props = __props



const getTipContent = () => {
  const value = t('此单包含X种运输方式，生成了Y个国际发货单')
  const num = props.resultData
  return (!num || num === 0) ? t('此订单已取消发货') : value.replace('X', String(num)).replace('Y', String(num))
}
/** 取消提交 */
const cancel = () => {
  emit('closeDialog', false)
  emit('refresh')
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    class: "problem-result-order",
    "custom-class": "problem-result-order",
    width: 500,
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('closeDialog', false))),
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: cancel,
          style: { marginRight: '24px' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('知道了')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "result-tip",
            innerHTML: getTipContent()
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})